import { render } from "./CargoPickupPage.html?vue&type=template&id=2d540056&scoped=true"
import script from "./CargoPickupPage.js?vue&type=script&lang=js"
export * from "./CargoPickupPage.js?vue&type=script&lang=js"

import "./CargoPickupPage.scss?vue&type=style&index=0&id=2d540056&lang=scss&scoped=true"
import "./CargoPickupPage.vue?vue&type=style&index=1&id=2d540056&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d540056"]])

export default __exports__